module.exports = __webpack_public_path__ + "static/img/13-1.913d511.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/13-1.jpg
// module id = LT+D
// module chunks = 0